import { State, Selector, Action, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';;
import { Injectable } from '@angular/core';
import { LoadAuditHistoryAction, LoadAuditHistoryFailAction, LoadAuditHistorySuccessAction, LoadAuditsHistoryAction, LoadAuditsHistoryFailAction, LoadAuditsHistorySuccessAction } from './audit.actions';
import { AuditEntityClient, AuditModel, AuditsModel } from '@core/services/api.service';

export class AuditStateModel {
  public isLoading: boolean;
  public AuditHistory: AuditModel[];
  public AuditsHistory: AuditsModel[];
}

@State<AuditStateModel>({
  name: 'auditHistory',
  defaults: {
    isLoading: false,
    AuditHistory:[],
    AuditsHistory:[],
  }
})
@Injectable()
export class AuditState {
  constructor(
     private auditHistoryClient: AuditEntityClient,
  ) { }

  @Selector()
  static getIsLoading(state: AuditStateModel) {
    return state.isLoading;
  }

  @Selector()
  static getAuditHistory(state: AuditStateModel) {
    return state.AuditHistory;
  }

  @Action(LoadAuditHistoryAction)
  LoadAuditHistoryAction({ dispatch, patchState }: StateContext<AuditStateModel>, action: LoadAuditHistoryAction) {
    patchState({ isLoading: true });
    return this.auditHistoryClient.getAuditHistory(action.entityId).pipe(
      tap((audits) => dispatch(new LoadAuditHistorySuccessAction({ audits }))),
      catchError((err) => dispatch(new LoadAuditHistoryFailAction()))
    );
  }

  @Action(LoadAuditHistorySuccessAction)
  LoadAuditHistorySuccessAction(ctx: StateContext<AuditStateModel>, action: LoadAuditHistorySuccessAction) {
    ctx.patchState({
      isLoading: false,
      AuditHistory: action.payload.audits,
    });
  }

  @Action(LoadAuditHistoryFailAction)
  LoadAuditHistoryFailAction(ctx: StateContext<AuditStateModel>, action: LoadAuditHistoryFailAction) {
    ctx.patchState({
      isLoading: false,
      AuditHistory: null
    });
  }


  @Selector()
  static getAuditsHistory(state: AuditStateModel) {
    return state.AuditsHistory;
  }

  @Action(LoadAuditsHistoryAction)
  LoadAuditsHistoryAction({ dispatch, patchState }: StateContext<AuditStateModel>, action: LoadAuditsHistoryAction) {
    patchState({ isLoading: true });
    return this.auditHistoryClient.getAuditsHistory(action.entityId).pipe(
      tap((audits) => dispatch(new LoadAuditsHistorySuccessAction({ audits }))),
      catchError((err) => dispatch(new LoadAuditsHistoryFailAction()))
    );
  }

  @Action(LoadAuditsHistorySuccessAction)
  LoadAuditsHistorySuccessAction(ctx: StateContext<AuditStateModel>, action: LoadAuditsHistorySuccessAction) {
    ctx.patchState({
      isLoading: false,
      AuditsHistory: action.payload.audits,
    });
  }

  @Action(LoadAuditsHistoryFailAction)
  LoadAuditsHistoryFailAction(ctx: StateContext<AuditStateModel>, action: LoadAuditsHistoryFailAction) {
    ctx.patchState({
      isLoading: false,
      AuditHistory: null
    });
  }
}
